
// import { Player } from '@lottiefiles/react-lottie-player';
// import gearsAnim from '../../../assets/video/under_development.mp4';
// //import gearsAnim from '../../../assets/lottie/ComingSoon.json';
// import React, { useRef, useEffect } from 'react';
// // const videoRef = useRef(null);

// // useEffect(() => {
// //     if (videoRef.current) videoRef.current.playbackRate = 0.85;
// // }, []);
// const ComingSoon = () => {
//     return (
//         <div style={s.root}>
//             {/* Background decorative circles */}
//             <div style={s.bgCircle1} />
//             <div style={s.bgCircle2} />

//             <div style={s.card}>
//                 {/* Badge */}
//                 <div style={s.badge}>
//                     <span style={s.badgeDot} />
//                     In Progress
//                 </div>

//                 {/* Animation */}
//                 <div style={s.animWrap}>
//                     {/* <video
//                         ref={videoRef}
//                         autoPlay
//                         loop
//                         muted
//                         playsInline
//                         style={s.video}
//                     >
//                         <source src={gearsAnim} type="video/mp4" />
//                     </video> */}

//                     <Player
//                         autoplay
//                         loop
//                         src={gearsAnim}
//                         style={{ width: '100%', height: '100%' }}
//                     />
//                 </div>

//                 {/* Text */}
//                 <h1 style={s.heading}>Under Development</h1>
//                 <p style={s.sub}>
//                     Our team is working hard to bring this feature to you.
//                     Check back soon for updates!
//                 </p>

//                 {/* Divider */}
//                 <div style={s.divider} />

//                 {/* Footer note */}
//                 <p style={s.footer}>
//                     🔧 &nbsp;Feature Coming Soon
//                 </p>
//             </div>
//         </div>
//     );
// };

// const s = {
//     root: {
//         //     minHeight: '100%',
//         //     width: '100%',
//         //     //background: 'linear-gradient(135deg, #eff6ff 0%, #f0f9ff 50%, #f5f3ff 100%)',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         padding: '2rem',
//         boxSizing: 'border-box',
//         position: 'relative',
//         overflow: 'hidden',
//     },
//     bgCircle1: {
//         position: 'absolute',
//         top: '-120px',
//         right: '-120px',
//         width: '400px',
//         height: '400px',
//         borderRadius: '50%',
//         background: 'radial-gradient(circle, rgba(99,102,241,0.1) 0%, transparent 70%)',
//         pointerEvents: 'none',
//     },
//     bgCircle2: {
//         position: 'absolute',
//         bottom: '-100px',
//         left: '-100px',
//         width: '350px',
//         height: '350px',
//         borderRadius: '50%',
//         background: 'radial-gradient(circle, rgba(59,130,246,0.1) 0%, transparent 70%)',
//         pointerEvents: 'none',
//     },
//     card: {
//         background: '#ffffff',
//         borderRadius: '24px',
//         boxShadow: '0 20px 60px rgba(0,0,0,0.08), 0 4px 16px rgba(0,0,0,0.04)',
//         padding: '3rem 4rem',
//         width: '100%',
//         maxWidth: '680px',          // ← wider card
//         minWidth: '320px',
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         textAlign: 'center',
//         position: 'relative',
//         zIndex: 1,
//         boxSizing: 'border-box',
//     },
//     badge: {
//         display: 'inline-flex',
//         alignItems: 'center',
//         gap: '6px',
//         background: '#eff6ff',
//         color: '#3b82f6',
//         fontSize: '0.75rem',
//         fontWeight: 600,
//         letterSpacing: '0.05em',
//         textTransform: 'uppercase',
//         padding: '6px 14px',
//         borderRadius: '999px',
//         marginBottom: '1.5rem',
//         border: '1px solid #bfdbfe',
//         whiteSpace: 'nowrap',
//     },
//     badgeDot: {
//         display: 'inline-block',
//         width: '7px',
//         height: '7px',
//         borderRadius: '50%',
//         background: '#3b82f6',
//     },
//     animWrap: {
//         width: '280px',
//         height: '220px',
//         marginBottom: '0.5rem',
//     },
//     heading: {
//         fontSize: '1.8rem',
//         fontWeight: 700,
//         color: '#1e3a5f',
//         margin: '0 0 0.75rem',
//         lineHeight: 1.3,
//         whiteSpace: 'nowrap',       // ← prevent wrapping/clipping
//     },
//     sub: {
//         fontSize: '0.95rem',
//         color: '#6b7280',
//         margin: '0',
//         lineHeight: 1.7,
//         maxWidth: '420px',
//     },
//     divider: {
//         width: '60px',
//         height: '3px',
//         background: 'linear-gradient(90deg, #3b82f6, #6366f1)',
//         borderRadius: '999px',
//         margin: '2rem auto',
//     },
//     footer: {
//         fontSize: '0.82rem',
//         color: '#9ca3af',
//         margin: 0,
//         letterSpacing: '0.01em',
//         whiteSpace: 'nowrap',
//     },
// };

// export default ComingSoon;

import React, { useRef, useEffect } from 'react';

const ComingSoon = () => {
    const videoRef = useRef(null);

    useEffect(() => {
        if (videoRef.current) videoRef.current.playbackRate = 0.85;
    }, []);

    return (
        <div style={s.root}>
            {/* Background decorative circles */}
            <div style={s.bgCircle1} />
            <div style={s.bgCircle2} />

            <div style={s.card}>
                {/* Badge */}
                <div style={s.badge}>
                    <span style={s.badgeDot} />
                    In Progress
                </div>

                {/* Video Animation */}
                <div style={s.animWrap}>
                    <video
                        ref={videoRef}
                        autoPlay
                        loop
                        muted
                        playsInline
                        style={s.video}
                    >
                        <source src={require('../../../assets/video/under_development.mp4')} type="video/mp4" />
                    </video>
                </div>

                {/* Text */}
                <h1 style={s.heading}>Under Development</h1>
                <p style={s.sub}>
                    Our team is working hard to bring this feature to you.
                    Check back soon for updates!
                </p>

                {/* Divider */}
                <div style={s.divider} />

                {/* Footer note */}
                <p style={s.footer}>
                    🔧 &nbsp;Feature Coming Soon
                </p>
            </div>
        </div>
    );
};

const s = {
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        boxSizing: 'border-box',
        position: 'relative',
        overflow: 'hidden',
    },
    bgCircle1: {
        position: 'absolute',
        top: '-120px',
        right: '-120px',
        width: '400px',
        height: '400px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(99,102,241,0.1) 0%, transparent 70%)',
        pointerEvents: 'none',
    },
    bgCircle2: {
        position: 'absolute',
        bottom: '-100px',
        left: '-100px',
        width: '350px',
        height: '350px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(59,130,246,0.1) 0%, transparent 70%)',
        pointerEvents: 'none',
    },
    card: {
        background: '#ffffff',
        borderRadius: '24px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.08), 0 4px 16px rgba(0,0,0,0.04)',
        padding: '3rem 4rem',
        width: '100%',
        height: '100%',
        //maxWidth: '680px',
        //minWidth: '320px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        //position: 'relative',
        zIndex: 1,
        boxSizing: 'border-box',
    },
    badge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        background: '#eff6ff',
        color: '#3b82f6',
        fontSize: '0.75rem',
        fontWeight: 600,
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
        padding: '6px 14px',
        borderRadius: '999px',
        marginBottom: '1.5rem',
        border: '1px solid #bfdbfe',
        whiteSpace: 'nowrap',
    },
    badgeDot: {
        display: 'inline-block',
        width: '7px',
        height: '7px',
        borderRadius: '50%',
        background: '#3b82f6',
    },
    animWrap: {
        width: '500px',
        height: '360px',
        marginBottom: '0.5rem',
        borderRadius: '12px',
        overflow: 'hidden',         // ← clips video to rounded corners if needed
    },
    video: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',       // ← use 'cover' if you want it to fill fully
    },
    heading: {
        fontSize: '1.8rem',
        fontWeight: 700,
        color: '#1e3a5f',
        margin: '0 0 0.75rem',
        lineHeight: 1.3,
        whiteSpace: 'nowrap',
    },
    sub: {
        fontSize: '0.95rem',
        color: '#6b7280',
        margin: '0',
        lineHeight: 1.7,
        maxWidth: '420px',
    },
    divider: {
        width: '60px',
        height: '3px',
        background: 'linear-gradient(90deg, #3b82f6, #6366f1)',
        borderRadius: '999px',
        margin: '2rem auto',
    },
    footer: {
        fontSize: '0.82rem',
        color: '#9ca3af',
        margin: 0,
        letterSpacing: '0.01em',
        whiteSpace: 'nowrap',
    },
};

export default ComingSoon;